import { useState } from "react";
import Game from "./game/Game";
import User from "./user/User";
import Chat from "./chat/Chat"

const Reports = () => {
  const [activeTab, setActiveTab] = useState("Game");

  return (
    <div className="px-md-2 px-1 py-md-2 py-1">
      {/* <h2 className="">Content Management System</h2> */}
      <ul className="nav nav-tabs">
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <span
            className={`nav-link ${activeTab === "Game" ? "active" : ""}`}
            onClick={() => setActiveTab("Game")}
            style={{
              color: activeTab !== "Game" ? "#2c3e50" : "",
              fontWeight: activeTab === "Game" ? "600" : "normal",
              fontSize: activeTab === "Game" ? "large" : "medium",
            }}
          >
            Game
          </span>
        </li>
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <span
            className={`nav-link ${activeTab === "User" ? "active" : ""}`}
            onClick={() => setActiveTab("User")}
            style={{
              color: activeTab !== "User" ? "#2c3e50" : "",
              fontWeight: activeTab === "User" ? "600" : "normal",
              fontSize: activeTab === "User" ? "large" : "medium",
            }}
          >
            User
          </span>
        </li>
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <span
            className={`nav-link ${
              activeTab === "Chat" ? "active" : ""
            }`}
            onClick={() => setActiveTab("Chat")}
            style={{
              color: activeTab !== "Chat" ? "#2c3e50" : "",
              fontWeight: activeTab === "Chat" ? "600" : "normal",
              fontSize: activeTab === "Chat" ? "large" : "medium",
            }}
          >
            Chat
          </span>
        </li>
      </ul>
      {activeTab === "Game" && <Game />}
      {activeTab === "User" && <User />}
      {activeTab === "Chat" && <Chat />}
    </div>
  );
};

export default Reports;
